interface IndexItem {
  title: string;
  count: string;
  icon: string;
  color: string;
}

const indexItems: IndexItem[] = [
  { title: '日漫热播', count: '8000+', icon: 'ri-sun-line', color: 'bg-accent-100 text-accent-600' },
  { title: '韩漫精选', count: '5000+', icon: 'ri-moon-line', color: 'bg-primary-100 text-primary-600' },
  { title: '国产动漫', count: '4000+', icon: 'ri-flag-2-line', color: 'bg-secondary-100 text-secondary-600' },
  { title: '热血冒险', count: '3000+', icon: 'ri-fire-line', color: 'bg-accent-100 text-accent-600' },
  { title: '恋爱校园', count: '2500+', icon: 'ri-heart-line', color: 'bg-primary-100 text-primary-600' },
  { title: '奇幻异世界', count: '2800+', icon: 'ri-magic-line', color: 'bg-secondary-100 text-secondary-600' },
  { title: '悬疑推理', count: '1800+', icon: 'ri-search-eye-line', color: 'bg-accent-100 text-accent-600' },
  { title: '搞笑日常', count: '2000+', icon: 'ri-emotion-laugh-line', color: 'bg-primary-100 text-primary-600' },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            专题索引
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[500px] mx-auto">
            日漫、韩漫、国漫全品类覆盖，按题材快速找到你想看的类型
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item, idx) => (
            <div
              key={idx}
              className="group cursor-pointer bg-background-100 hover:bg-background-200/70 rounded-xl p-5 md:p-6 transition-colors"
            >
              <div className={`w-11 h-11 flex items-center justify-center rounded-xl ${item.color} mb-4`}>
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors mb-1.5">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500">{item.count} 部作品</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}